// @flow

import React, { useRef } from 'react';
import { BrowserView } from 'react-device-detect';

import { jobs as t } from 'helpers/translation';
import useOutsideClick from 'core/hooks/useOutsideClick';
import useSetState from 'core/hooks/useSetState';
import BtnRounded from 'components/BtnRounded';

type Props = {
  search: any,
  updateSearch: Function,
  pushToSearch: Function,
  urlSearch: string
};

type StateProps = {
  value: string,
  keywordPillsHidden: boolean
};

export default ({ search, updateSearch, pushToSearch, urlSearch }: Props) => {
  const [{ value, keywordPillsHidden }, setState] = useSetState<StateProps>({
    value: '',
    keywordPillsHidden: false
  });

  const searchRef = useRef<any>(null);
  const inputRef = useRef<any>(null);

  useOutsideClick(searchRef, () => {
    setState({ value: '', keywordPillsHidden: false });
  });

  const handleInputChange = ({ target }) => setState({ value: target.value });

  const handleInputClick = ({ target }) => {
    setState({
      keywordPillsHidden: true,
      value: target.getAttribute('keywords')
    });
  };

  const handleSubmit = e => {
    e.preventDefault();

    inputRef.current.blur();

    const uniqValues = [...new Set(value.split('+'))];

    updateSearch({ ...search, q: uniqValues.join('+'), page: 1 });

    setState({ keywordPillsHidden: false, value: '' });
  };

  const handlePillClick = e => {
    pushToSearch({ q: e.target.getAttribute('keyword'), page: 0 }, 'remove');
  };

  const clearFilters = () => {
    setState({ value: '' });
    updateSearch({});
  };

  return (
    <div className="row">
      <div className="col-12">
        <form
          className="jobs-search"
          ref={searchRef}
          onSubmit={e => handleSubmit(e)}
        >
          <i
            className="jobs-search__icon icon-search"
            role="button"
            onClick={handleSubmit}
            onKeyDown={handleSubmit}
            tabIndex="0"
          > </i>
          <div className="jobs-search__result">
            {search.q && search.q.split('+').map(item => (
              <BtnRounded
                key={item}
                iconAfter='close-o'
                text={item}
                type='primary'
                classes={`jobs-search__btn ${keywordPillsHidden ? ' hidden' : ''}`}
                handleDelete={e => handlePillClick(e)}
              />))
            }
            <input
              type="text"
              id="q"
              name="q"
              ref={inputRef}
              className="jobs-search__input"
              onChange={e => handleInputChange(e)}
              value={value}
              onClick={e => handleInputClick(e)}
              keywords={search.q || ''}
              placeholder={!search.q ? t.search_bar.placeholder : ''}
            />
          </div>
          <BrowserView renderWithFragment="true">
            {urlSearch && <button
              className="jobs-search__reset"
              onClick={() => clearFilters()}
              type="button"
            >{t.search_bar.clear_filters}</button>
            }
            <button
              className="jobs-search__submit btn btn_primary"
              type="submit"
            >{t.search_bar.search_now}</button>
          </BrowserView>
        </form>
      </div>
    </div>
  );
};
